<template>
    <div>
        <gofix-card class="mb-0" fullContent>
            <gofix-default-table class=""
                :settings="tableConfig"
                :table-items="tableItems"
                @load-items="getTableData"
                @delete-items="deleteItems"
                ref="gofixTable">
                <template slot="gofix_table:created_at" slot-scope="row">
                    {{row.item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                </template>
                <template slot="gofix_table:remark" slot-scope="row">
                    <div v-if="checkIsJson(row.item.remark)">
                        <json-viewer
                            :value="row.item.remark | isJson"
                            :expand-depth="0"
                            sort></json-viewer>
                    </div>
                    <div v-else v-html="row.item.remark"></div>
                </template>
            </gofix-default-table>
        </gofix-card>
    </div>
</template>

<script>
    import JsonViewer from 'vue-json-viewer';
    import { filters } from '@/_filterVar.js';
    import { fileIcons } from "@/_commonVar.js";
    export default {
        name: 'safety-activities',
        props: {
            activityType: {
                type: String,
                default: null
            },
            activityId: {
                type: [String,Number],
                default: null
            },
            controls: {
                type: Object,
                default: () => {
                    return {
                        create: false,
                        delete: false,
                        update: true,
                    }
                }
            },
            nameTable: {
                type: String,
                default: 'finance-activity-log'
            },
            item: {
                type: Object,
                default: () => {},
            },
        },
        components: {
            JsonViewer,
        },
        data() {
            let filter =  JSON.parse(JSON.stringify(filters['activities']));
            return {
                tableConfig:{
                    name: this.nameTable,
                    controls:{
                        create: true,
                        delete: true,
                        tableImport: false,
                        tableExport: false,
                        update:true
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "created_at",
                    sortDirection: "desc",
                    fields: [
                        {
                            key: 'created_at',
                            label: 'Time Stamp',
                            isActive: 1,
                            isFilter: true,
                            with:150,
                            thStyle: "width:150px",
                            sorting: true,
                        }
                        ,{
                            key: 'action',
                            label: 'Activity',
                            thStyle: "width:180px",
                            isActive: 1,
                            isFilter: true,
                            with:150,
                            sorting: true,
                        },
                        {
                            key: 'actor_name',
                            label: 'User',
                            isActive: 1,
                            isFilter: true,
                            with:150,
                            thStyle: "width:150px",
                            sorting: true,
                        },
                        {
                            key: 'remark',
                            label: 'Remark',
                            isActive: 1,
                            isFilter: true,
                            with:null,
                            thStyle: "width:auto",
                            sorting: true,
                        },
                    ]
                },
                tableItems: []
            }
        },
        watch: {
            controls: function(val) {
                this.tableConfig.controls = Object.assign(this.tableConfig.controls, val);
            },
        },
        filters: {
            isJson(value) {
                try {
                    JSON.parse(value);
                } catch (e) {
                    return value;
                }
                return JSON.parse(value);
            },
            iconFile(val, is_svg = false) {
                const icons = fileIcons
                let path = 'img/';
                let type_show = 'img';
                let extension = '';
                let name = val.image_file_name || val.name;
                let type = val.type || val.image_content_type;

                if(is_svg) {
                    path = '';
                    type_show = 'svg';
                }
                if(val.type) extension = name.split('.')[1];

                let arrTemp = type.split('/');
                if(arrTemp && arrTemp.length == 2) {
                    let type = arrTemp[0];
                    if(!extension) extension = arrTemp[1];

                    if(type == 'application' || type == 'inode' || type == 'text') {
                        let key = 'pdf';
                        if(['docx', 'doc', 'vnd.openxmlformats-officedocument.wordprocessingml.document', 'msword'].includes(arrTemp[1])) key = 'word';
                        if(['xls', 'xlsx', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'vnd.ms-excel'].includes(arrTemp[1])) key = 'excel';
                        if(['zip', 'x-empty', 'plain'].includes(arrTemp[1])) {
                            let extension = name.split('.')[1];
                            if(['doc', 'docx'].includes(extension)) key = 'word';
                            if(['xls', 'xlsx', 'csv'].includes(extension)) key = 'excel';
                            if(['txt'].includes(extension)) key = 'text';
                        }
                        return `${path}${icons['application'][key][type_show]}`;
                    }

                    return `${path}${icons[type][type_show]}`;
                }
            }
        },
        async created() {
           this.tableConfig.controls = Object.assign(this.tableConfig.controls, this.controls);
        },
        methods: {
            renameField() {
                if(this.isCaseActivity) {
                    this.tableConfig.fields.forEach(item => {
                        if( item.key === 'created_at' ) {
                            item.label = 'Date & Time';
                        }
                        if (item.key === 'action') {
                            item.label = 'Action';
                        }
                    })
                }
            },
            /* ---- Get data ----------------------------------------------------*/
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.work_item_id.value = this.activityId;
                tableRequest.filter.work_item_type.value = this.activityType;
                await this.$store.dispatch("SafetyAppController/getActivityLogs", tableRequest)
                    .then(response => {
                        this.tableItems = response.data.data.items;
                        this.tableConfig.total = response.data.data.total;
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            async deleteItems(callback){},

            /* ---- Attributes ----------------------------------------------------*/
            checkIsJson(item){
                if(!item) return false;
                try {
                    let json_ = JSON.parse(item);
                    
                    if ( typeof(json_) == 'string' ) {
                        return false;
                    } else {
                        return true;
                    }
                } catch (e) {
                    return false;
                }
                return true;
            },
        }
    }
</script>
